// src/layouts/MainLayout.tsx
import React, { useMemo, useState } from 'react';
import { useLocation, Outlet } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
// import MobileBottomNav from '../../components/MobileBottomNav'; // ⛔️ 底部ナビ視目解決済み
import { useAuth } from '../../context/AuthContext';

interface MainLayoutProps {
  ipAllowed: boolean;
}

const MainLayout: React.FC<MainLayoutProps> = ({ ipAllowed }) => {
  const location = useLocation();
  const { isAuthenticated } = useAuth();
  const [/* chatVisible */, setChatVisible] = useState(false); // 保留状态以防后续扩展

  const path = location.pathname;

  // 路由特征用 useMemo，避免重复计算
  const isDoctorPage = useMemo(() => path.startsWith('/doctor'), [path]);
  const isAdminPage  = useMemo(() => path.startsWith('/admin'),  [path]);
  const isHeroPage   = useMemo(() => ['/', '/login', '/lp'].includes(path), [path]);
  const isUserPage   = useMemo(() => !isDoctorPage && !isAdminPage, [isDoctorPage, isAdminPage]);

  // 仅控制左右 padding 的白名单（首页通常由页面自身控制）
  const noPaddingPaths = ['/', '/home'];
  const isNoPadding = useMemo(() => {
    return noPaddingPaths.includes(path) || 
           path.startsWith('/mypage') ||
           path.startsWith('/menu') || 
           path.startsWith('/about') || 
           path.startsWith('/faq') ||
           path.startsWith('/privacy') ||
           path.startsWith('/legal') ||
           path.startsWith('/security') ||
           path.startsWith('/contact');
  }, [path]);

  return (
    <div className="flex flex-col min-h-screen bg-background text-foreground">
      {/* 全局滚动偏移，配合固定 Navbar，避免 #anchor 被遮住 */}
      <Helmet>
        <style>{`
          html { scroll-padding-top: 72px; }
          @media (min-width: 768px) {
            html { scroll-padding-top: 88px; }
          }
        `}</style>
      </Helmet>

      {/* 可访问性：键盘用户可快速跳过导航 */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 focus:bg-coral focus:text-white focus:px-3 focus:py-2 focus:rounded"
      >
        Skip to content
      </a>

      <Navbar ipAllowed={ipAllowed} />
      <main
        id="main-content"
        className={[
          'flex-grow flex flex-col',
          isNoPadding ? '' : 'px-4 sm:px-6 lg:px-8',
          isHeroPage ? '' : 'pt-[72px] md:pt-[88px]',
        ].join(' ')}
      >
        <Outlet />
      </main>

      <Footer />
      {/* ⛔️ MobileBottomNav は一時停止 */}
      {/* {isUserPage && isAuthenticated && <MobileBottomNav />} */}
    </div>
  );
};

export default MainLayout;
